import React from 'react';
import { SPACING_SECTION, SPACING_BUTTON } from '../constants/layout';

export default function Loading({ message = "Loading…" }) {
  return (
    <div
      style={{
        width: '100%',
        minHeight: '50vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'var(--color-background)',
        padding: `${SPACING_SECTION} ${SPACING_BUTTON}`,
        boxSizing: 'border-box',
      }}
    >
      <div style={{
        width: '40px',
        height: '40px',
        border: '3px solid var(--color-border)',
        borderTop: '3px solid var(--color-accent)',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
      }}></div>
      <p style={{
        marginTop: '12px',
        fontSize: '14px',
        color: 'var(--color-text-secondary)',
        margin: `${SPACING_BUTTON} 0 0 0`
      }}>
        {message}
      </p>
      
      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
